import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchBulletinIdByVehSystem = (vehSystem) => {
  return apiActionCreator({
    'endpoint': `/bulletin/sequence/${vehSystem}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_BULLETIN_SEQUENCE_BY_VEH_SYSTEM,
      ActionTypes.FETCHED_BULLETIN_SEQUENCE_BY_VEH_SYSTEM,
      [
        ActionTypes.FETCHED_BULLETIN_SEQUENCE_BY_VEH_SYSTEM_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'form',
    'method': 'GET',
  });
};

export const fetchBulletinById = (id) => {
  return apiActionCreator({
    'endpoint': `/bulletin/${id}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_BULLETIN_BY_ID,
      ActionTypes.FETCHED_BULLETIN_BY_ID,
      [
        ActionTypes.FETCHED_BULLETIN_BY_ID_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'form',
    'method': 'GET',
  });
};

export const addNewBulletin = (data) => {
  return apiActionCreator({
    'endpoint': '/bulletin',
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_NEW_BULLETIN_SERVICE,
      [
        ActionTypes.ADDED_NEW_BULLETIN_SERVICE,
        MessageActions.addMessageBoxInfo('Boletin creado satisfactoriamente'),
      ],
      [
        ActionTypes.ADDED_NEW_BULLETIN_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'form',
    'method': 'POST',
    data,
  });
};

export const updateBulletinById = (id, data = {}) => {
  return apiActionCreator({
    'endpoint': `/bulletin/${id}`,
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_BULLETIN_BY_ID,
      [
        () => {
          return {
            'type': ActionTypes.UPDATED_BULLETIN_BY_ID,
          };
        },
        (response) => MessageActions.addMessageBoxInfo(response.data),
      ],
      [
        ActionTypes.UPDATED_BULLETIN_BY_ID_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'form',
    'method': 'PUT',
    data,
  });
};

export const downloadExcelRecord = (id) => {
  return apiActionCreator({
    'endpoint': `/bulletin/record/${id}?&excel=S`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOADING_BULLETIN_RECORD_FILE,
      ActionTypes.DOWNLOADED_BULLETIN_RECORD_FILE,
      [
        ActionTypes.DOWNLOADED_BULLETIN_RECORD_FILE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const saveDowloadRecord = (data) => {
  return apiActionCreator({
    'endpoint': '/bulletin/record',
    'authenticated': true,
    'types': [
      ActionTypes.SAVING_BULLETIN_DOWNLOAD_RECORD,
      ActionTypes.SAVED_BULLETIN_DOWNLOAD_RECORD,
      [
        ActionTypes.SAVED_BULLETIN_DOWNLOAD_RECORD_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'contentType': 'application/json',
    'method': 'POST',
    'data': data,
  });
};

export const fetchDowloadRecord = (bulletinId) => {
  return apiActionCreator({
    'endpoint': `/bulletin/record/${bulletinId}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_BULLETIN_DOWNLOAD_RECORD,
      ActionTypes.FETCHED_BULLETIN_DOWNLOAD_RECORD,
      [
        ActionTypes.FETCHED_BULLETIN_DOWNLOAD_RECORD_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const sendBulletinMail = (data) => {
  return apiActionCreator({
    'endpoint': '/bulletin/mail',
    'authenticated': true,
    'types': [
      ActionTypes.SENDING_BULLETIN_MAIL,
      ActionTypes.SENDED_BULLETIN_MAIL,
      [
        ActionTypes.SENDED_BULLETIN_MAIL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'contentType': 'application/json',
    'method': 'POST',
    'data': data,
  });
};

export const setBulletinAttachments = (files) => ({
  'type': ActionTypes.SET_BULLETIN_FILES,
  'payload': files,
});

export const clearBulletinForm = () => ({
  'type': ActionTypes.CLEAR_BULLETIN_INFO,
});

export const clearBulletinURLFile = () => ({
  'type': ActionTypes.CLEAR_BULLETIN_URL_FILE,
});
